<i18n>
{
  "fr": {
    "back-btn": "Retourner aux réglages",
    "page-title": "Modifier un utilisateur",
    "manage-business-title": "Réglages"
  },
  "en": {
    "back-btn": "Back to settings",
    "page-title": "Edit user",
    "manage-business-title": "Réglages"
  }
}
</i18n>

<template>
  <div class="card">
    <ui-box class="has-background-primary">
      <router-link :to="{ name: $consts.urls.URL_BUSINESS_DETAIL, query: { tab: 'users' } }" class="has-text-white">
        <span class="icon">
          <i class="fas fa-arrow-left"></i>
        </span>
        <span class="has-text-underline">{{ $t('back-btn') }}</span>
      </router-link>
      <h1 class="title is-2 has-text-weight-bold has-text-white mt-12px">{{ $t('page-title') }}</h1>
    </ui-box>
    <ui-box>
      <user-form v-if="user" is-edit :is-self="isSelf" @submit="updateUser" v-model="user" :loading="loading" />
      <s-loader :active="!user" />
    </ui-box>
  </div>
</template>

<script>
import BusinessService from '@/services/business'

import { URL_BUSINESS_DETAIL } from '@/consts/urls'

import Breadcrumbs from '@/mixins/breadcrumbs'
import UiBox from '@/components/ui/box'
import UserForm, { mapGraphToModel } from '@/components/businesses/user-form'

export default {
  mixins: [Breadcrumbs],
  components: { UiBox, UserForm },
  data() {
    return {
      currentUserId: null,
      user: null,
      loading: false
    }
  },
  computed: {
    isSelf() {
      return this.currentUserId === this.$route.params.id
    },
    breadcrumbs() {
      return [
        {
          label: this.$t('manage-business-title'),
          url: { name: URL_BUSINESS_DETAIL, query: { tab: 'users' } }
        },
        {
          label: this.$t('page-title')
        }
      ]
    },
    currentBusinessId() {
      return BusinessService.getCurrentBusiness().id
    }
  },
  methods: {
    async updateUser() {
      this.loading = true

      try {
        const input = {
          businessId: this.currentBusinessId,
          userId: this.$route.params.id,
          firstName: { value: this.user.firstName },
          lastName: { value: this.user.lastName },
          position: { value: this.user.position },
          language: { value: this.user.language }
        }

        if (!this.isSelf) {
          input.type = { value: this.user.type }
        }

        await this.$apollo.mutate({
          mutation: this.$withFragments(this.$options.mutation.UpdateUserBusiness, UserForm.fragments.formFields),
          variables: {
            input
          }
        })

        this.$success()

        this.$router.push({ name: URL_BUSINESS_DETAIL, query: { tab: 'users' } })
      } finally {
        this.loading = false
      }
    }
  },
  apollo: {
    userToEdit: {
      query() {
        return this.$withFragments(this.$options.query.UserBusiness, UserForm.fragments.formFields)
      },
      variables() {
        return {
          businessId: this.currentBusinessId,
          userId: this.$route.params.id
        }
      },
      update(data) {
        this.currentUserId = data.me.id
        this.user = mapGraphToModel(data.userBusiness)
      },
      fetchPolicy: 'network-only'
    }
  }
}
</script>

<graphql>
query UserBusiness($businessId: ID!, $userId: ID!) {
  me {
    id
  }
  userBusiness(businessId: $businessId, userId: $userId) {
    id
    ...formFields
  }
}

mutation UpdateUserBusiness($input: UpdateUserBusinessInput!) {
  updateUserBusiness(input: $input) {
    userBusiness {
      id
      ...formFields
    }
  }
}
</graphql>